import { render, staticRenderFns } from "./DomainWhitelistEditable.vue?vue&type=template&id=84585bc4&"
import script from "./DomainWhitelistEditable.vue?vue&type=script&lang=js&"
export * from "./DomainWhitelistEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports